import React from 'react'
import Image from "next/image";
import { Blur, Remote } from "@/api/loaderRemote";
import Link from "next/link";

const MobileStoresItem = ({ category }) => {
  return (
    <Link href={category.url} prefetch={false} passHref>
      <div className="flex flex-col items-center w-20">
        <div className="w-[4.25rem] h-[4.25rem] flex items-center justify-center border-2 rounded-full">
          <Image
            src={category.icon ? `/images/${category.icon}` : "/no.png"}
            alt={category.title}
            width={40}
            height={40}
            loader={category.icon ? Remote : undefined}
            blurDataURL={category.icon ? Blur(category.icon) : undefined}
            className="object-contain"
          />
        </div>
        <div className="flex flex-col text-center font-bold text-[0.688rem] mt-1">
          <span>{category.baslik}</span>
        </div>
      </div>
    </Link>
  );
}

export default MobileStoresItem